import { Link } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";

export const Paso3Container = styled(motion.div)`
  width: 100%;
  padding: 0 14px;
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
  .spinner {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const Paso3SMGContainer = styled(motion.div)`
  width: 100%;
  padding: 0 14px;
  margin-top: 60px;
  justify-content: space-between;
  .ValidaTurno-separador {
    height: 2px;
    margin: 20px;
    background-color: var(--color-grey95);
  }
  .spinner {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const Paso3Titulo = styled.div`
  display: flex;
  justify-content: center;
`;

export const Paso3Body = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 44px;
  .ValidaTurno-bodytxt {
    text-align: center;
  }
  .ValidaTurnoSmg-bodytxt {
    text-align: center;
    width: 80%;
    margin-top: 50px;
  }
  .ValidaTurnoSmg-titulo {
    text-align: center;
  }
  .ValidaTurno-input{
    width: 190px;
  }
`;
export const Paso3ContainerBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .btn-validaturno{
    padding: 10px;
    min-width: 156px;
    height: 54px;
  }
  
`;

export const Paso3ContainerBotonesSMG = styled.div`
  display: flex;
  flex-direction: column ;
  width: 10%;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-top: 80px;
  .btn-validaturno{
    padding: 10px;
    min-width: 300px;
    height: 54px;
  }
  
`;
